var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo"},[_c(_setup.CartaoNotaFiscalEmitida,{attrs:{"dado":_setup.props.dado}}),_c(_setup.TabelaDeContasAReceber,{attrs:{"dado":_setup.props.dado},on:{"update:alteraContaAReceber":_setup.alteraContaAReceber}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }